module.exports = __webpack_public_path__ + "static/Gotham-UltraItalic-7e85c14bf1afa8a40da75aae508f4943.woff2";